import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-compass-white",
  "use": "default-compass-white-usage",
  "viewBox": "0 0 12 30",
  "content": "<symbol viewBox=\"0 0 12 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"default-compass-white\"><path d=\"M11.647 0v16.984L.353 30V13.06L11.647 0zM5.025 12.909a2.3 2.3 0 00-1.102 3.06 2.3 2.3 0 003.052 1.122 2.3 2.3 0 001.102-3.06 2.3 2.3 0 00-3.052-1.122z\" fill=\"#FFF\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol